<template>
    <tr>
        <td>
            {{row.trekksoft_activity_name}}
        </td>
        <td>
            {{row.trekksoft_activity_id}}
        </td>
        <td class="text-center">
            {{row.count_schedulers}}
        </td>
        <td  class="text-center" :class="row.count_unconfigured_schedulers > 0 ? 'text-danger font-weight-bold' : 'text-success'">
            {{row.count_unconfigured_schedulers}}
        </td>
        <td>
            <span :class="row.count_active > 0 ? 'font-weight-bold' : ''">
                {{row.count_active > 0 ? 'Sí (' + row.count_active + ')' : 'No'}}
            </span>
        </td>
        <td>
            <i v-if="row.count_unconfigured_schedulers > 0" class="fa fa-exclamation-triangle mr-2 text-warning" aria-hidden="true" title="Configurada parcialmente o sin configurar"></i>
            <i v-else class="fa fa-check-circle mr-2 text-success" aria-hidden="true" title="Totalmente configurada"></i>
        </td>
        <td>
            {{ row.source_integration }}
        </td>
        <!-- <td>
            <span v-if="row.activity_duration_type != null">{{ row.activity_duration_type.name }} ({{ row.activity_duration_type.code }})</span>
            <span v-else>-</span>
        </td> -->
        <td>
            {{ row.count_with_only_ticket }}
        </td>
        <td>
            <b-button
                class="border"
                size="sm"
                variant="light"
                v-b-modal="'editActivityAdmin_' + row.trekksoft_activity_id"
            >
                    <i class="text-center fa fa-wrench fa-fw"></i>
                    
            </b-button>
            <edit-activity-schedulers-modal :activityId="row.trekksoft_activity_id" />
        </td>
    </tr>
</template>

<script>
/* eslint-disable */
import EditActivitySchedulersModal from './EditActivitySchedulersModal'

export default {
    components: {
        EditActivitySchedulersModal
    },
    props: {
        row: {
            type: Object,
            required: true
        }
    },
    methods: {
        async togglePickupService() {
            console.log('toogle pickup service')
            const data = {
                activity_id: this.row.id
            }
            this.$store.dispatch('activities/togglePickupService', data)
        }
    }
}
</script>